import {useState} from "preact/compat";

export const useItem = () => {
    // State to control the store info modal display state
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Handler for the "isModalOpen" state
    const handleModal = (state) => {
        setIsModalOpen(state);
    }

    return {
        isModalOpen,
        handleModal
    }
}